import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=05b4082c&scoped=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
import style0 from "./settings.vue?vue&type=style&index=0&id=05b4082c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4082c",
  null
  
)

export default component.exports